import { registerFeature } from "../registry";
import { DraftReplyAction } from "./DraftReplyAction";

registerFeature({
  id: "draft-reply",
  label: "Draft Reply",
  description: "Generate a draft reply to the current email.",
  Component: DraftReplyAction,
});
